module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-mobile-1.d73aae08.png";